var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('h3',[_vm._v(_vm._s(_vm.title)+"分类")]),_vm._t("default",function(){return [_vm._v(" 我是默认的一些内容 ")]},{"games":_vm.games,"msg":"hello"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }